import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    flex: 1,
    display: 'flex',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    flexDirection: 'row',
    color: theme.palette.text.secondary,
    overflow: 'auto',
  },

  textTitleCard: {
    fontWeight: 'bold',
  },

  paperSummaryAudit: {
    flexDirection: 'column',
  },

  dataGrid: {
    '& .MuiDataGrid-cell': {
      minHeight: '0 !important',
      maxHeight: 'none !important',
      '& .cellTolltip': {
        display: 'block',
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
      },
    },
  },
}))
